// extracted by mini-css-extract-plugin
export var emptyState = "_6u-d";
export var statCard = "_6u-c";
export var table = "_6u-0";
export var tableCell = "_6u-4";
export var tableCellClickable = "_6u-5 _6u-4";
export var tableCellDefault = "_6u-6 _6u-4";
export var tableCellEmpty = "_6u-8";
export var tableCellWithValue = "_6u-7";
export var tableContainer = "_6u-e";
export var tableHeaderWeight = "_6u-1";
export var tableHeaderZone = "_6u-2";
export var tableRowHeader = "_6u-3";
export var viewModeButton = "_6u-9";
export var viewModeButtonActive = "_6u-a _6u-9";
export var viewModeButtonInactive = "_6u-b _6u-9";